import React, { useState } from "react";
import Disc from "./Disc.jsx";
import { useFetch, loading } from "../../helpers/hooks.jsx";
import json_data from "./Discography.json";
import json_navbar from "../UI/Navbar/Navbar.json";
import "./discography.css";

const Discography = ({ lang }) => {
  const [lastPlayingCD, setLastPlayingCD] = useState(-1);
  const [lastPlayingTrack, setLastPlayingTrack] = useState(-1);

  const [CDs, loadingCDs, changeCD] = useFetch("./mp3/cd_list.json");

  const stopLastPlaying = (idCD, idTrack) => {
    let updateCDs = [...CDs];
    let lastCD = { ...updateCDs[idCD] };
    lastCD.trackList[idTrack].playing = false;
    updateCDs[idCD] = lastCD;
    changeCD(updateCDs);
  };

  const onPlay = (idCD, idTrack) => {
    // check if track chnaged
    let trackChanged = !(idCD === lastPlayingCD && idTrack === lastPlayingTrack);

    // change playing sttate
    let isPlaying = CDs[idCD].trackList[idTrack].playing;
    let updateCDs = [...CDs];

    // reset state of lastPlaying
    if (trackChanged & (lastPlayingCD > -1)) {
      let lastCD = { ...updateCDs[lastPlayingCD] };
      lastCD.trackList[lastPlayingTrack].playing = false;
      updateCDs[lastPlayingCD] = lastCD;
    }

    let newCD = { ...updateCDs[idCD] };
    newCD.trackList[idTrack].playing = !isPlaying;
    updateCDs[idCD] = newCD;

    changeCD(updateCDs); // ??
    setLastPlayingCD(idCD);
    setLastPlayingTrack(idTrack);

    // play or stop
    const x = document.getElementById("myAudio");
    if (trackChanged) {
      x.src = "/mp3/" + newCD.trackList[idTrack].src;
    }
    newCD.trackList[idTrack].playing ? x.play() : x.pause();

    x.onended = function () {
      stopLastPlaying(idCD, idTrack);
      if (CDs[idCD].trackList.length > idTrack + 1) onPlay(idCD, idTrack + 1);
    };
  };

  return (
    <div className="discography">
      <h1>{json_navbar.discography[lang]}</h1>
      <audio id="myAudio">
        <source src="/mp3/CD1/01_-_Gavotte_en_Rondeau.mp3" type="audio/mp3" />
        Your browser does not support the audio element.
      </audio>{" "}
      <div className="discography-message">
        <p>{json_data.message[lang]}</p>
      </div>
      {loadingCDs
        ? loading[lang]
        : CDs.map((CD, index) => (
            <Disc key={index} idCD={index} lang={lang} CD={CD} onPlay={onPlay} />
          ))}
    </div>
  );
};

export default Discography;



// WEBPACK FOOTER //
// ./src/components/Discography/Discography.jsx